const deps = {};

class TutorialsController {
  constructor($state, $rootScope, $timeout, laboxSSapi, navigationManager, $scope, $window, analyticsService, storage) {
    this.$timeout = $timeout;
    this.name = 'Tutorials';
    this.$rootScope = $rootScope;
    this.menuitems = [];
    this.menuitemsLoader = true;
    this.$state = $state;
    deps.$state = $state;
    navigationManager.registerViewComponent(this, $scope, 'home.tutorials');

    if (storage.getItem('session', 'plant_id') && storage.getItem('session', 'plant_id') == 1) {
      laboxSSapi.getOptVideoTutorials().then((res) =>{
        if(res && res.data && !res.data.labox_video_tutorials.length == 0){
          const tutorialarray = []; 
          // omniture when tutorials load successfully		
          console.log('!!omniture when tutorials load successfully!!');
        	analyticsService.sendReport('tutorials', 'tutorials', 'event1', null, null, null, null, null, 
            this.$rootScope.omnitureBillingStatus, this.$rootScope.omniturePaperlessbill);      
              
          const groups = _.groupBy(res.data.labox_video_tutorials[0].labox_videos, subgroup => subgroup.position_id);
          for (const key in groups) {
            tutorialarray.push({
              title: groups[key][0].title,
              link: groups[key][0].video_image,
              url: groups[key][0].video
            });
            this.menuitems = tutorialarray;
            this.menuitemsLoader = false;
          }
          // this.menuitems[0].url = "http://static.tvlistings.optimum.net/laboxfaq/stage/labox-videos/EO_Channel900introRevisionOct2016.mp4";
          // this.menuitems[1].url = "https://vid-west-online.web.sundaysky.com/amz1/w2s67/flvstreamer?jobId=836cab55-910e-4f03-8e8a-479ddb6cca12&authToken=0b5a01b06ddd42108028f15a57178f23&videoId=webm&reqId=089fc028-65a3-4cb6-88d2-412d68d42ca5";
          // this.menuitems[1].url = "http://news12li.videodownload.worldnow.com/NEWS12LI_2509201707550300000AB.mp4";
          // this.menuitems[1].url = "http://news12li.videodownload.worldnow.com/NEWS12LI_20170924182553303AB.mp4";
          // this.menuitems[2].url = "http://stage.avn.cv.net/static/samples/NEWS12LI_20170924182553303AB.mp4";
          // this.menuitems[3].url = "http://media.exploreoptimum.iptv.optimum.net/EO_Channel900introRevisionOct2016.mp4"
          // this.menuitems[3].url = "https://www.optimum.net/cdn/img.optimum.net/video/laboxfaq/stage/labox-videos/4977_Optimum_Voice_Remote_test.mp4";
        } else {
          // omniture when tutorials load successfully
          console.log('!!omniture when tutorials with API error!!');
          analyticsService.sendReport('tutorials', 'tutorials', 'event1', 'api error', null, null, null, null,
            this.$rootScope.omnitureBillingStatus, this.$rootScope.omniturePaperlessbill);

          this.$rootScope.fromTutorialPage = true;
          this.menuitemsLoader = false;
          this.$state.go('home.landingpage');
        }
      },(reserr)=>{
        console.log('fail ---> ',reserr);
        this.$rootScope.fromTutorialPage = true;
        this.menuitemsLoader = false;
        this.$state.go('home.landingpage');
      });
    } else if (storage.getItem('session', 'plant_id') && storage.getItem('session', 'plant_id') == 2) {
      laboxSSapi.getSdlVideoTutorials().then((res) =>{
        if(res && res.data && !res.data.labox_video_tutorials.length == 0){
          const tutorialarray = []; 
          // omniture when tutorials load successfully    
          console.log('!!omniture when tutorials load successfully!!');
          analyticsService.sendReport('tutorials', 'tutorials', 'event1', null, null, null, null, null, 
            this.$rootScope.omnitureBillingStatus, this.$rootScope.omniturePaperlessbill);      
              
          const groups = _.groupBy(res.data.labox_video_tutorials[0].labox_videos, subgroup => subgroup.position_id);
          for (const key in groups) {
            tutorialarray.push({
              title: groups[key][0].title,
              link: groups[key][0].video_image,
              url: groups[key][0].video
            });
            this.menuitems = tutorialarray;
            this.menuitemsLoader = false;
          }
          // this.menuitems[0].url = "http://static.tvlistings.optimum.net/laboxfaq/stage/labox-videos/EO_Channel900introRevisionOct2016.mp4";
          // this.menuitems[1].url = "https://vid-west-online.web.sundaysky.com/amz1/w2s67/flvstreamer?jobId=836cab55-910e-4f03-8e8a-479ddb6cca12&authToken=0b5a01b06ddd42108028f15a57178f23&videoId=webm&reqId=089fc028-65a3-4cb6-88d2-412d68d42ca5";
          // this.menuitems[1].url = "http://news12li.videodownload.worldnow.com/NEWS12LI_2509201707550300000AB.mp4";
          // this.menuitems[1].url = "http://news12li.videodownload.worldnow.com/NEWS12LI_20170924182553303AB.mp4";
          // this.menuitems[2].url = "http://news12li.videodownload.worldnow.com/NEWS12LI_2109201713205200000AB.mp4";
        } else {
          // omniture when tutorials load successfully
          console.log('!!omniture when tutorials with API error!!');
          analyticsService.sendReport('tutorials', 'tutorials', 'event1', 'api error', null, null, null, null,
            this.$rootScope.omnitureBillingStatus, this.$rootScope.omniturePaperlessbill);

          this.$rootScope.fromTutorialPage = true;
          this.menuitemsLoader = false;
          this.$state.go('home.landingpage');
        }
      },(reserr)=>{
        console.log('fail ---> ',reserr);
        this.$rootScope.fromTutorialPage = true;
        this.menuitemsLoader = false;
        this.$state.go('home.landingpage');
      });
    } else {
      this.$rootScope.fromTutorialPage = true;
      this.menuitemsLoader = false;
      this.$state.go('home.landingpage');
    }
  }
}

TutorialsController.$inject = [
  '$state',
  '$rootScope',
  '$timeout',
  'laboxSSapi',
  'navigationManager',
  '$scope',
  '$window',
  'analyticsService',
  'storage'
];

export default TutorialsController;



// WEBPACK FOOTER //
// ./client/app/components/tutorials/tutorials.controller.js